var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n8"
  }, [_vm._l(_vm.seekers, function (seeker) {
    return [_c('v-col', {
      key: seeker._id,
      staticClass: "pa-8",
      attrs: {
        "cols": "12"
      }
    }, [_c('auth-seekers-item', _vm._g(_vm._b({}, 'auth-seekers-item', {
      seeker,
      selected: _vm.selected
    }, false), {
      toggle: _vm.toggle
    }))], 1)];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }